import { render, staticRenderFns } from "./adList.vue?vue&type=template&id=8a10084a&scoped=true&"
import script from "./adList.vue?vue&type=script&lang=js&"
export * from "./adList.vue?vue&type=script&lang=js&"
import style0 from "./adList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./adList.vue?vue&type=style&index=1&id=8a10084a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a10084a",
  null
  
)

component.options.__file = "adList.vue"
export default component.exports